import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 32 32"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", { d: "M16 32c-4.4 0-8.2-1.6-11.3-4.7A15.4 15.4 0 0 1 0 16c0-4.4 1.6-8.2 4.7-11.3C7.7 1.6 11.6 0 16 0a15.5 15.5 0 0 1 13 6.4V0h3v12.7H19.3v-3h8.4q-1.95-3-4.8-4.8C20.9 3.5 18.6 3 16 3c-3.6 0-6.7 1.3-9.2 3.8A12.5 12.5 0 0 0 3 16c0 3.6 1.3 6.7 3.8 9.2a13.1 13.1 0 0 0 21.6-4.9h3.1A16 16 0 0 1 16 32" }, null, -1)
  ]));
}
const Refresh = { render };
export {
  Refresh as default,
  render
};
//# sourceMappingURL=Refresh.svg.js.map
